var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.183,4.406C38.956,3.56 38.511,2.789 37.893,2.169C37.274,1.549 36.504,1.103 35.659,0.874C32.527,0.014 19.997,0 19.997,0C19.997,0 7.469,-0.014 4.335,0.808C3.491,1.048 2.722,1.502 2.104,2.124C1.485,2.747 1.037,3.518 0.803,4.364C-0.023,7.496 -0.031,13.992 -0.031,13.992C-0.031,13.992 -0.039,20.52 0.781,23.62C1.241,25.334 2.591,26.688 4.307,27.15C7.471,28.01 19.967,28.024 19.967,28.024C19.967,28.024 32.497,28.038 35.629,27.218C36.473,26.988 37.243,26.542 37.863,25.923C38.483,25.305 38.931,24.536 39.163,23.692C39.991,20.562 39.997,14.068 39.997,14.068C39.997,14.068 40.037,7.538 39.183,4.406ZM15.989,20.01L15.999,8.01L26.413,14.02L15.989,20.01Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.9e1968070f5e33f5bde8a3a114e53958.svg";
export { ForwardRef as ReactComponent };